import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { AppConstants } from 'src/app/shared/app.constants';
import { RemoveIfNoAccessDirective } from 'src/app/shared/directives/remove-if-no-access.directive';
import { AuthorizationByStatusModel } from 'src/app/shared/models/authorization-model';

@Component({
  selector: 'ness-crime-gun-results',
  templateUrl: './crime-gun-results.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RemoveIfNoAccessDirective]
})
export class CrimeGunResultsComponent {
  @Input() isPrintView: boolean = false;
  @Input() loading: boolean = false;
  @Input() showAddIR: boolean = false; 

  private _relatedResults: ServerModels.ResultTableViewModel[] = [];
  public get relatedResults(): ServerModels.ResultTableViewModel[] {
    return this._relatedResults;
  }
  @Input() public set relatedResults(results: ServerModels.ResultTableViewModel[]) {
    this.loading = results == null;
    this._relatedResults = results;

    if (results != null) {
      this.toggleIconClass = results.length > 0 ? 'fas fa-minus-square' : 'fas fa-plus-square';
    }
  }

  private _hasAuthOrgCode: boolean = false;
  @Input() set authOrgId(ids: string[]) {
    this._hasAuthOrgCode = this.authService.hasUserType(['ATFHQ', 'StateLocalLE']) || this.authService.hasRole(['NESS Administrator']) ? true :
      ids?.map(x => x.toUpperCase()).includes(this.authService.authOrgCode?.toUpperCase());
  }

  get authOrgCode(): boolean {
    return this._hasAuthOrgCode;
  }

  @Output() showResultDetails = new EventEmitter<string>(true);
  @Output() addResult = new EventEmitter();
  cols: any[] = [
    { field: 'Status', header: 'Status' },
    { field: 'TrackingNumber', header: 'Results Tracking #' },
    { field: 'CreatedBy', header: 'Created By' },
    { field: 'CreatedDate', header: 'Created Date' },
    { field: 'LastUpdateDate', header: 'Last Updated Date' },
    { field: 'Defendants', header: 'Defendant(s)' }
  ];


  rows: number = AppConstants.defaultTableRows;
  toggleIconClass: string = 'fas fa-minus-square';

  constructor(private authService: AuthService) { }

  public canCreate(): AuthorizationByStatusModel {
    return {
      canCreate: this.authOrgCode,
      role: ['NESS Administrator'],
      userType: [],
      entityState: AppConstants.Result_FormMode_Add,
      roleUserType: [
        {
          roles: ['Application Administrator', 'Power User', 'Editor'],
          userType: 'ATFFieldDivision'
        },
        {
          roles: ['Application Administrator', 'Editor'],
          userType: 'StateLocalLE'
        }
      ]
    } as AuthorizationByStatusModel;
  }

  public toggleClass(state: string): void {
    if (state === 'hide') {
      this.toggleIconClass = 'fas fa-plus-square';
    }
    if (state === 'show') {
      this.toggleIconClass = 'fas fa-minus-square';
    }
  }
}
